import React from 'react';
import { Container } from './styles';
import Logo from '../../assets/images/logo-header.png';

const TopHeader = () => (
  <Container className="main-header">
    <img src={Logo} alt="Divulgaí" />
  </Container>
);

export default TopHeader;



// WEBPACK FOOTER //
// ./src/components/TopHeader/index.js